import DashboardContainer from "./DashboardContainer";

export default DashboardContainer;